import { render, staticRenderFns } from "./memberEvents.vue?vue&type=template&id=4c532fdd"
import script from "./memberEvents.vue?vue&type=script&lang=js"
export * from "./memberEvents.vue?vue&type=script&lang=js"
import style0 from "./memberEvents.vue?vue&type=style&index=0&id=4c532fdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports